const shimmer = 'animate-pulse bg-muted/60';

export const InstrumentListSkeleton = () => (
  <div className="min-h-screen bg-background">
    <div className="pt-32 md:pt-40 pb-12 px-6">
      <div className="max-w-5xl mx-auto space-y-4">
        <div className={`h-3 w-32 ${shimmer}`} />
        <div className={`h-12 w-72 ${shimmer}`} />
        <div className={`h-px w-20 bg-gold/30 mt-8`} />
        <div className={`h-5 w-96 ${shimmer} mt-4`} />
      </div>
    </div>
    <div className="px-6 pb-12">
      <div className="max-w-5xl mx-auto flex gap-2">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className={`h-9 w-20 ${shimmer}`} />
        ))}
      </div>
    </div>
    <div className="px-6 pb-20">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="space-y-4">
            <div className={`aspect-[4/3] ${shimmer}`} />
            <div className={`h-6 w-48 ${shimmer}`} />
            <div className={`h-3 w-32 ${shimmer}`} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const InstrumentDetailSkeleton = () => (
  <div className="min-h-screen bg-background">
    <div className="pt-28 px-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <div className={`h-4 w-40 ${shimmer}`} />
        <div className={`aspect-[4/3] max-w-3xl ${shimmer}`} />
        <div className="flex gap-2">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className={`w-16 h-16 ${shimmer}`} />
          ))}
        </div>
        <div className={`h-px w-16 bg-gold/30`} />
        <div className={`h-10 w-64 ${shimmer}`} />
        <div className={`h-4 w-48 ${shimmer}`} />
        <div className={`h-20 w-full max-w-xl ${shimmer}`} />
      </div>
    </div>
  </div>
);

export const AtelierSkeleton = () => (
  <div className="min-h-screen bg-background">
    <div className="pt-32 md:pt-40 pb-12 px-6">
      <div className="max-w-5xl mx-auto space-y-4">
        <div className={`h-3 w-24 ${shimmer}`} />
        <div className={`h-12 w-80 ${shimmer}`} />
        <div className={`h-px w-20 bg-gold/30 mt-8`} />
        <div className={`h-24 w-full max-w-2xl ${shimmer} mt-4`} />
      </div>
    </div>
  </div>
);

export const ContactSkeleton = () => (
  <div className="min-h-screen bg-background">
    <div className="pt-32 md:pt-40 pb-12 px-6">
      <div className="max-w-5xl mx-auto space-y-4">
        <div className={`h-12 w-48 ${shimmer}`} />
        <div className={`h-px w-20 bg-gold/30 mt-6`} />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mt-8">
          <div className="space-y-4">
            <div className={`h-20 w-full ${shimmer}`} />
          </div>
          <div className="space-y-4">
            {[1, 2, 3, 4].map(i => (
              <div key={i} className={`h-12 w-full ${shimmer}`} />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);
